export default __webpack_public_path__ + "static/media/entsoe_logo.7cc0a15c.svg";